export const Check = () => (
  <svg
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
    className="text-completed"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      rx="5.5"
      width="11"
      height="11"
      fill="currentColor"
      stroke="currentColor"
    />

    <path
      d="M8.625 4.125L4.95 7.875L3.375 6.46875"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
